import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../../../src/core/api/axiosClient";

const initialState: any = {
  motionTrafficReports: [],
  isLoading: false,
  error: null,
  downloadMotionTrafficReportsFile: [],
  isLoadingMotionTrafficReportsDownload: false,
};

export const getMotionTrafficReports: any = createAsyncThunk(
  "content/getMotionTrafficReport",
  async ({
    tcCode = null,
    siteCode = null,
    blockCode = null,
    reportType = null,
    startDate = null,
    endDate = null,
    timePeriod = null,
    asset = null,
  }: any) => {
    const payload = {
      tcCode,
      siteCode,
      blockCode,
      reportType,
      startDate,
      endDate,
      timePeriod,
      asset,
    };
    const res = await axios.post(
      `/slpapp/Report/getMotionTrafficReport`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    const data = await res.data;
    return data;
  }
);

export const downloadMotionTrafficReportsFile: any = createAsyncThunk(
  "content/downloadMotionTrafficReportsFile",
  async ({
    fileType = "downloadPdf",
    tcCode = null,
    siteCode = null,
    blockCode = null,
    reportType = null,
    startDate = null,
    endDate = null,
    timePeriod = null,
    asset = null,
  }: any) => {
    const payload = {
      tcCode,
      siteCode,
      blockCode,
      reportType,
      startDate,
      endDate,
      timePeriod,
      asset,
    };

    try {
      const response = await axios.post(
        `/slpapp/Report/getMotionTrafficReport/${fileType}`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
          responseType: "blob",
        }
      );

      let filename = response.headers["content-disposition"]
        .split(";")
        .find((n: any) => n.includes("filename="))
        .replace("filename=", "")
        .trim();

      let fileBlob;
      if (fileType === "downloadPdf") {
        fileBlob = new Blob([response.data], { type: "application/pdf" });
      } else {
        fileBlob = new Blob([response.data], {
          type: "application/application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
      }

      const fileUrl = URL.createObjectURL(fileBlob);

      const link = document.createElement("a");
      link.href = fileUrl;
      // if (fileType === "downloadPdf") {
      //   link.download = filename;
      // } else {
      //   link.download = filename;
      // }
      link.download = filename;

      link.click();

      URL.revokeObjectURL(fileUrl);

      return response.data;
    } catch (error) {
      console.error("Error downloading motion traffic report:", error);
      throw error;
    }
  }
);

export const motionTrafficReportSlice = createSlice({
  name: "motionTrafficReport",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getMotionTrafficReports.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getMotionTrafficReports.fulfilled, (state, action) => {
      state.isLoading = false;
      state.motionTrafficReports = action.payload;
    });
    builder.addCase(getMotionTrafficReports.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });

    builder.addCase(downloadMotionTrafficReportsFile.pending, (state) => {
      state.isLoadingMotionTrafficReportsDownload = true;
    });
    builder.addCase(
      downloadMotionTrafficReportsFile.fulfilled,
      (state, action) => {
        state.isLoadingMotionTrafficReportsDownload = false;
        state.downloadMotionTrafficReportsFile = action.payload;
      }
    );
    builder.addCase(
      downloadMotionTrafficReportsFile.rejected,
      (state, action) => {
        state.isLoadingMotionTrafficReportsDownload = false;
        state.error = action.error.message;
      }
    );
  },
});

export default motionTrafficReportSlice.reducer;
